import React from 'react';
import { Link } from 'react-router-dom';
import { LoadingSpinner, EmptyState, Button } from '../ui';

/**
 * ClaimsTab - Manage pending prompt ownership claims
 */
const ClaimsTab = ({ claims, loading, onApprove, onReject }) => {
  if (loading) {
    return <LoadingSpinner size="lg" text="Loading claims..." />;
  }

  if (claims.length === 0) {
    return (
      <EmptyState
        title="No pending claims"
        message="Users can claim auto-imported prompts if they're the original authors."
      />
    );
  }

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold dark:text-white">Pending Claims</h2>

      <div className="overflow-x-auto rounded-lg border dark:border-spooky-purple-mist">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-50 dark:bg-spooky-bg-light">
            <tr className="border-b dark:border-spooky-purple-mist">
              <th className="py-3 px-4 dark:text-white">Title</th>
              <th className="py-3 px-4 dark:text-white">Source</th>
              <th className="py-3 px-4 dark:text-white">Claimant</th>
              <th className="py-3 px-4 dark:text-white">Posted Prompt</th>
              <th className="py-3 px-4 dark:text-white">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y dark:divide-spooky-purple-mist">
            {claims.map((claim) => (
              <tr key={claim.id} className="hover:bg-gray-50 dark:hover:bg-spooky-bg-light dark:text-white">
                <td className="py-3 px-4">
                  <div className="font-semibold">{claim.title}</div>
                  <div className="text-xs text-gray-500 truncate max-w-xs">{claim.source_url}</div>
                </td>
                <td className="py-3 px-4">
                  {claim.source_platform || '-'}
                  {claim.source_author && ` (@${claim.source_author})`}
                </td>
                <td className="py-3 px-4">{claim.claimant_username || '-'}</td>
                <td className="py-3 px-4">
                  {claim.posted_prompt_id ? (
                    <Link
                      className="text-boop-primary hover:underline"
                      to={`/prompts/${claim.posted_prompt_id}`}
                    >
                      View
                    </Link>
                  ) : (
                    <span className="text-gray-400">Not posted</span>
                  )}
                </td>
                <td className="py-3 px-4">
                  <div className="flex gap-2">
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => onApprove(claim.id)}
                    >
                      Approve
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => onReject(claim.id)}
                    >
                      Reject
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClaimsTab;
